import type { Step } from "react-joyride";

export const auditRecordListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການບັນທຶກການກວດສອບ! ຫນ້ານີ້ຈະສະແດງລາຍການບັນທຶກການກວດສອບທັງໝົດ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-toolbar"]',
    content:
      "ນີ້ແມ່ນແຖບເຄື່ອງມື. ທ່ານສາມາດກົດປຸ່ມ 'ສ້າງບັນທຶກໃໝ່' ເພື່ອສ້າງບັນທຶກການກວດສອບໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-filter"]',
    content:
      "ນີ້ແມ່ນຕົວກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາ, ກອງຕາມຜົນການກວດສອບ (ຜ່ານ/ບໍ່ຜ່ານ/ຕ້ອງປັບປຸງ), ຫຼືສະຖານະ (ຮ່າງ/ສຳເລັດ) ເພື່ອຊອກຫາບັນທຶກທີ່ຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງບັນທຶກການກວດສອບ. ທ່ານຈະເຫັນລາຍການບັນທຶກການກວດສອບທັງໝົດ. ກົດທີ່ແຖວເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];

